import { AppDefinition } from '../../types/apps';

export const DIAGRAM_EVENTS = {
  OPEN: 'DIAGRAM_OPEN',
  CHANGE: 'DIAGRAM_CHANGE',
  EXPORT: 'DIAGRAM_EXPORT',
  AI_OPS: 'DIAGRAM_AI_OPS',
} as const;

export const DiagramAppDefinition: AppDefinition = {
  appId: 'diagram',
  name: 'Diagram',
  version: '0.1.0',
  description:
    'Real-time collaborative diagrams (architecture, scientific cohort, flows) with full Figma-class layout and style control. AI drafts the structure; humans finalize.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'ChartScatter',
    phosphorWeight: 'duotone',
    color: '#0ea5e9',
    metadata: { source: 'app', appId: 'diagram', isAppIcon: true },
  },
  entityIcons: {
    Diagram: {
      type: 'phosphor',
      phosphorIcon: 'ChartScatter',
      phosphorWeight: 'duotone',
      color: '#0ea5e9',
    },
  },
  events: DIAGRAM_EVENTS,
  entityTypes: ['Diagram'],
  // The Y.Doc is the source of truth; only the small skeleton mirror is
  // ever indexed. Never include base64, records, or thumbnailSvg.
  searchableSkeletonFields: {
    Diagram: ['description', 'tags'],
  },
  component: 'DiagramApp',
  requiresProps: false,
  requiresEntity: true,
  agenticToolIds: [
    'diagram_create',
    'diagram_edit',
    'diagram_read',
  ],
  actions: {},
  hidden: true,
};
